import {
  UpdateErrorType,
  ValidationErrorEnum
} from '../../../pages/Orders/LongSteelOrders/OrdersTabs/Tables/OpenOrdersTable/UpdateOrder';
import { EMeasureUnit } from '../../commomTypes';
import { ICustomer } from '../customers/types';
import { IMeasureUnit } from '../long-steel-shopping-cart/types';

// Action Types
export enum Types {
  LOAD_LONG_STEEL_ORDERS_FROM_LOCAL_STORAGE = 'orders/LOAD_LONG_STEEL_ORDERS_FROM_LOCAL_STORAGE',
  CLEAR_ORDERS_STATE = 'orders/CLEAR_ORDERS_STATE',

  LOAD_LONG_STEEL_ORDERS = 'orders/LOAD_LONG_STEEL_ORDERS',
  LOAD_LONG_STEEL_ORDERS_SUCCESS = 'orders/LOAD_LONG_STEEL_ORDERS_SUCCESS',
  LOAD_LONG_STEEL_ORDERS_FAILURE = 'orders/LOAD_LONG_STEEL_ORDERS_FAILURE',

  LOAD_TRACKING_FLAT_STEEL = 'orders/LOAD_TRACKING_FLAT_STEEL',
  LOAD_TRACKING_FLAT_STEEL_SUCCESS = 'orders/LOAD_TRACKING_FLAT_STEEL_SUCCESS',
  LOAD_TRACKING_FLAT_STEEL_FAILURE = 'orders/LOAD_TRACKING_FLAT_STEEL_FAILURE',

  LOAD_TRACKING_LONG_STEEL = 'orders/LOAD_TRACKING_LONG_STEEL',
  LOAD_TRACKING_LONG_STEEL_SUCCESS = 'orders/LOAD_TRACKING_LONG_STEEL_SUCCESS',
  LOAD_TRACKING_LONG_STEEL_FAILURE = 'orders/LOAD_TRACKING_LONG_STEEL_FAILURE',

  LOAD_BILLED_ORDER_TRACKING = 'orders/LOAD_BILLED_ORDER_TRACKING',
  LOAD_BILLED_ORDER_TRACKING_SUCCESS = 'orders/LOAD_BILLED_ORDER_TRACKING_SUCCESS',
  LOAD_BILLED_ORDER_TRACKING_FAILURE = 'orders/LOAD_BILLED_ORDER_TRACKING_FAILURE',

  LOAD_QC_FILE = 'orders/LOAD_QC_FILE',
  LOAD_QC_FILE_SUCCESS = 'orders/LOAD_QC_FILE_SUCCESS',
  LOAD_QC_FILE_FAILURE = 'orders/LOAD_QC_FILE_FAILURE',
  DOWNLOAD_QC_FILE = 'orders/DOWNLOAD_QC_FILE',

  LOAD_NF_FILE = 'orders/LOAD_NF_FILE',
  LOAD_NF_FILE_SUCCESS = 'orders/LOAD_NF_FILE_SUCCESS',
  LOAD_NF_FILE_FAILURE = 'orders/LOAD_NF_FILE_FAILURE',
  DOWNLOAD_NF_FILE = 'orders/DOWNLOAD_NF_FILE',

  LOAD_SHIPPING_NOTE_FILE = 'orders/LOAD_SHIPPING_NOTE_FILE',
  LOAD_SHIPPING_NOTE_FILE_SUCCESS = 'orders/LOAD_SHIPPING_NOTE_FILE_SUCCESS',
  LOAD_SHIPPING_NOTE_FILE_FAILURE = 'orders/LOAD_SHIPPING_NOTE_FILE_FAILURE',
  DOWNLOAD_SHIPPING_NOTE_FILE = 'orders/DOWNLOAD_SHIPPING_NOTE_FILE',

  CG_QC_FILE_REQUEST = 'orders/CG_QC_FILE_REQUEST',
  CG_QC_FILE_REQUEST_SUCCESS = 'orders/CG_QC_FILE_REQUEST_SUCCESS',
  CG_QC_FILE_REQUEST_FAILURE = 'orders/CG_QC_FILE_REQUEST_FAILURE',
  CG_QC_FILE_DOWNLOAD = 'orders/CG_QC_FILE_DOWNLOAD'
}

export enum EOrderTab {
  OPEN = 'open',
  BILLED = 'billed'
}

export enum ELongSteelOrdersStatus {
  ALL = 'all',
  PENDING = 'pending', // Saldo
  DELIVERY = 'delivery', // Em remessa
  SHIPMENT = 'shipment', // Em carregamento
  BILLED = 'billed', // Faturado
  CANCELLED = 'cancelled' // Cancelado
}

export enum EOpenColumn {
  ORDER_NUMBER = '0',
  OV_GERDAU = '1'
}

export enum EMaterialOpenColumn {
  GERDAU_MATERIAL = '0',
  CLIENT_MATERIAL = '1'
}

export interface ILongSteelOrdersState extends ILongSteelOrdersResponse {
  loading: boolean;
  error: boolean;
  initialized: boolean;
}

export interface ILongSteelOrdersResponse extends IOrdersCustomResponse {
  items: ILongSteelOrderData[];
  lastLoadTime?: number;
}

export interface IOrdersCustomResponse {
  receivers?: ICustomer[];
  emitters?: ICustomer[];
  divisions: IOrderDivision[];

  initialInputValues: IOrdersInitialInputValues;

  minOrderDate?: string;
  maxOrderDate?: string;

  bpError?: boolean;
}

export interface IOrdersInitialInputValues {
  states: string[];
  emitterIds: string[];
  receiverId: string;
  receiverBilledId?: string;
  orderStatus: ELongSteelOrdersStatus;
  startDate?: string;
  endDate?: string;
  tab: EOrderTab;
}

export interface IOrderDivision {
  division: string;
  divisionDescription: string;
}
export interface ILongSteelOrderData {
  id: string;
  shipTo: ILongSteelOrderCustomer;
  soldTo: ILongSteelOrderCustomer;
}

export enum EOrderType {
  PLANOS = 'Planos',
  LONGOS = 'Longos'
}

export interface ILongSteelOrderCustomer {
  address: string;
  city: string;
  code: string;
  country: string;
  name: string;
  neighborhood: string;
  state: string;
  taxNumber: string;
  zipCode: string;
}

// EM ABERTO
export interface IOpenOrderData extends ILongSteelOrderData, IOrderDivision {
  salesOrder: number;
  customerOrder: string;
  customerOrderItem: string;
  customerSKU: string;
  itemCancelledDate: string;
  itemCreationDate: string;
  requestedDate: string;
  materialDescription: string;
  orderType: EOrderType;
  plant: string;
  plantDescription: string;
  sku: number;
  salesOrderItem: number;
  status: string;
  futureDeliveries: IFutureDelivery[];

  salesOrg: string;

  conditions: IOpenOrderConditions;
  quantities: IOpenOrderQuantities;
  trackingFlatSteel?: ITrackingFlatSteelState;
  trackingFlatsteelExcel: ITrackingFlatSteel;

  trackingLongSteel?: ITrackingLongSteelState;
}

interface ITrackingLongSteelState {
  loading: boolean;
  error: boolean;
  longSteel?: ITrackingLongSteel;
}

export interface ITrackingLongSteel {
  billing: {
    billingQuantity: string;
    measureUnit: EMeasureUnit;
    tracking: ITrackingLongSteelItemData[];
  };
  deliveries: {
    deliveryQuantity: string;
    measureUnit: EMeasureUnit;
    tracking: ITrackingLongSteelItemData[];
  };
  shipments: {
    shipmentQuantity: string;
    measureUnit: EMeasureUnit;
    tracking: ITrackingLongSteelItemData[];
  };
}
export interface ITrackingLongSteelItemData {
  date: string;
  measureUnit: EMeasureUnit;
  quantity: string;
}

export interface IFutureDelivery {
  estimatedDeliveryDate: string;
  estimatedDeliveryMeasureUnit: EMeasureUnit;
  estimatedDeliveryQuantity: string;
}

interface ITrackingFlatSteelState {
  loading: boolean;
  error: boolean;
  flatsteel?: ITrackingFlatSteel;
}

export interface ITrackingFlatSteel {
  openQuantity: number; //Saldo da Ordem
  meltShop: number; //Aciaria
  rollingMill: number; //Laminação
  rollingFinish: number; //LA
  finish: number; //Acabamento
  stockMill: number; //Estoque Usina
  transit: number; //Em Transferência
  stockWarehouse: number; //Estoque Entre-Posto

  billedPercentual: string;
  billedQuantity: number;
  checkDate: number;
  clientOrderNumber: string;
  confirmedDate: string;
  fillRateDate: string;
  itemDescription: string;
  itemNumber: string;
  orderStatus: string;
  orderType: string;
  percentageOpen: number;
  port: number;
  productionAlert: string;
  requestedDate: string;
  requestedQuantity: number;
  requestedQuantityUnitMeasure: string;
  salesOrder: string;
  shipment: number;
  toleranceType: string;
  transportDoc: number;
  unitMeasure: string;
}

interface IOpenOrderConditions {
  aliquotIcms: string;
  icms: string;
  ipi: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  st: string;
  totalValueWithTaxes: string;
  totalValueWithoutIpi: string;
  totalValueWithoutTaxes: string;
  unitPriceWithTaxes: string;
  unitPriceWithTaxesUnit: string;
  unitPriceWithoutTaxes: string;
  unitPriceWithoutTaxesUnit: string;
  unitPriceCustomerFlatSteel: string;
}

export interface IOpenOrderQuantities {
  billedConversionQuantity: string;
  billedMeasureUnit: EMeasureUnit;
  billedQuantity: string;
  deliveryConversionQuantity: string;
  deliveryDate: string;
  deliveryMeasureUnit: EMeasureUnit;
  deliveryQuantity: string;
  pendingConversionQuantity: string;
  pendingMeasureUnit: EMeasureUnit;
  pendingQuantity: string;
  requestedConversionQuantity: string;
  requestedMeasureUnit: EMeasureUnit;
  requestedQuantity: string;
  shipmentConversionQuantity: string;
  shipmentMeasureUnit: EMeasureUnit;
  shipmentQuantity: string;
}

// FATURADOS
export interface IBilledOrderData extends ILongSteelOrderData {
  billingNumber: string;
  cqNumber: string;
  danfeNumber: string;
  deliveryCode: string;
  deliveryDocumentZvoi: string;
  deliveryItemCode: string;
  invoiceNumber: string;
  invoiceZvoi: string;
  itemBillingDate: string;
  nfeAccessKey: string;
  productionBatch: string;
  dueDate: string[];
  billingHistory: {
    customerOrder: string;
    customerSKU: string;
    division: string;
    divisionDescription: string;
    itemCreationDate: string;
    loteAdminSKU: string;
    materialDescription: string;
    orderType: string;
    plant: string;
    plantDescription: string;
    salesOrder: number;
    salesOrderItem: number;
    sku: number;
    salesOrganization: string;
    statusQC?: CgCertificateStatus;
  };

  quantities: IBilledOrderQuantities;
  conditions: IBilledOrderConditions;

  trackingState: IBilledOrderTrackingState;
  qcState: IQCColumnState;
  nfState: INFEColumnState;
  shippingNoteState?: IShippingNoteColumnState;
}

export enum CgCertificateStatus {
  Available = 'available',
  Processing = 'processing',
  NotFound = 'not-found',
  Ready = 'ready',
  Error = 'error',
  ErrorMail = 'error-mail'
}

export interface ICgCertificateRequest {
  sku: string;
  code: string;
  plant: string;
  deliveryCode: string;
  deliveryItemCode: string;
  invoiceNumber: string;
  salesOrder: string;
  salesOrderItem: string;
  statusQC: CgCertificateStatus;
  product: string;
  productionBatch: string;
}

export interface ICgCertificateResponse {
  ok: boolean;
  content: [
    {
      status: CgCertificateStatus;
      order_id: string;
      filename?: string;
      buffer?: string;
    }
  ];
}

interface IBilledOrderTrackingState {
  loading: boolean;
  error: boolean;
  tracking?: IBilledOrderTracking;
}
export interface IBilledOrderTracking {
  accessKey: string;
  billedDate: string;
  customerCity: string;
  customerName: string;
  customerPurchaseOrder: string;
  customerTaxNumber: string;
  deliveryDate: string;
  estimateDate: string;
  gerdauTaxNumber: string;
  invoice: string;
  plantCity: string;
  plantName: string;
  transportStatus: string;

  transportData: [
    {
      carrierName: string;
      carrierTaxNumber: string;
      loadingDate: string;
      loadingEndDate: string;
      loadingStatus: string;
      modalType: string;
    }
  ];

  transportLog: [
    {
      createdDate: string;
      receiver: {
        name: string;
        type: string;
      };
      transportType: 'entrada' | 'saida';
    }
  ];
}

interface IBilledOrderQuantities {
  billedConversionQuantity: number;
  billingMeasureUnit: EMeasureUnit;
  billingQuantity: number;
  requestedConversionQuantity: number;
  requestedMeasureUnit: EMeasureUnit;
  requestedQuantity: number;
}

export interface IBilledOrderConditions {
  unitPriceWithTaxes: string;
  invoiceItemValueWithTaxes: string;
  invoiceItemValueWithoutTaxes: string;
  invoiceTotalValueWithTaxes: string;
  invoiceTotalValueWithoutTaxes: string;
  invoiceVolume: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  salesTotalValueWithTaxes: string;
  unitPriceWithoutTaxes: string;
  unitPriceWithoutTaxesUnit: string;
}

export interface IDownloadNFEResponse {
  FILE: string;
  XML: string;
}

export interface IQCFileResponse {
  qcFile: {
    files: {
      cqId: string;
      deliveryItemNumber: string;
      status: 'SUCCESS' | 'FAILED';
    }[];
    qcBase64File: string;
  };
}

export interface IQCColumnState {
  canDownloadQC: boolean;
  qcFileResponse?: IQCFileResponse;
  // Essa tipagem mudará quando aceitarmos download em batch
  cgQcCertificateResponse?: ICgCertificateResponse['content'][0];
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface INFEColumnState {
  canDownloadNF: boolean;
  downloadNFEResponse?: IDownloadNFEResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface IShippingNoteColumnState {
  downloadNFEResponse?: IDownloadNFEResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface ordersType {
  [index: string]: string;
}

export interface IUpdateOrderValidation {
  customer: string;
  orderId: string;
}

export interface IUpdateOrderValidationResponse {
  orderId: string;
  sku: string;
  soldTo: string;
  shipTo: string;
  changeAllowed: boolean;
  reasonNotAllowed?: ValidationErrorEnum;
}

export interface IOrdersChangeData {
  soldTo: string;
  shipTo: string;
  details: [
    {
      gerdauSku: string;
      clientSku?: string | null;
      skuQuantity?: string | null;
      skuMeasureUnity?: string | null;
      desiredDate?: string | null;
      customerPurchaseItem?: string | null;
    }
  ];
}

export interface IOrdersChageDataResponse {
  sku: string;
  measureUnits: IMeasureUnit[];
}

export interface IUpdateOrderRequest {
  customer: string;
  customerType: 'soldTo'; // atualmente só se pode fazer a alteração de pedido para RECEBEDOR
  salesOrder: string;
  salesOrderItem: string;
  quantity?: string; //newVolume
  unityMeasure?: EMeasureUnit;
  requiredDate?: string;
  status?: 'cancelado';
  reasonMessage?: string;
  editMessage?: string;
}

export interface IUpdateOrderResponse {
  salesOrder: string;
  salesOrderItem: string;
  requestEditStatus: 'processando' | 'rejeitado' | 'não processado';
  errors: IUpdateOrderResponseError[];
}

export interface IUpdateOrderResponseError {
  attribute: UpdateErrorType;
  errorMessage: string;
}

export enum EModalMessageErrorType {
  SHIPMENT = 'remessa',
  SPECIAL = 'especial',
  PROCCESS = 'processo'
}
